import { INQUISITIVE_SITE } from 'global/constants';
import { AnchorStyled } from 'approot/shared/styles/typography.style';

export const ListInquisitiveLink = () => {
  return (
    <li>
      Go to{' '}
      <AnchorStyled href={INQUISITIVE_SITE} target="_blank">
        inquisitive.com
      </AnchorStyled>
    </li>
  );
};

export const ListStudentSignIn = () => {
  return (
    <li>
      Choose <strong>Sign In</strong> and then <strong>I’m a Student</strong>
    </li>
  );
};
